import { createSlice } from '@reduxjs/toolkit';
import { capitalize } from 'helpers/utils';
import _ from 'lodash';
import moment from 'moment';
import idGenerator from 'util/idGenerator';
import { notificationMessage } from 'util/billingNotificationTime';

export const notificationSlice = createSlice({
  name: 'notification',
  initialState: {
    notifications: [],
    inboxUnreadCount: 0,
    inboxOwnerGuid: null,
    inboxError: null
  },

  reducers: {
    clearInboxSession: state => {
      state.notifications = state.notifications.filter(
        item => !item.persistent
      );
      state.inboxUnreadCount = 0;
      state.inboxOwnerGuid = null;
      state.inboxError = null;
    },

    replaceInboxPage: (state, action) => {
      const { userGuid, page } = action.payload;
      state.inboxOwnerGuid = userGuid;
      state.inboxUnreadCount = page.UnreadCount || 0;
      state.inboxError = null;
      const transient = state.notifications.filter(item => !item.persistent);
      const persisted = (page.Objects || []).map(item => ({
        id: item.GUID,
        avatar: { name: item.Title || 'Jurat', size: 'xl' },
        children: notificationMessage(item),
        plainText: true,
        time: item.CreatedUtc,
        unread: item.Unread,
        to: item.ActionUrl,
        persistent: true,
        className: 'rounded-0 border-x-0 border-300 border-bottom-0'
      }));
      state.notifications = [...transient, ...persisted];
    },
    setInboxError: (state, action) => {
      state.inboxError = action.payload;
    },

    addShareRequestNotification: (state, action) => {
      const { id, event, to } = action.payload;
      if (state.notifications.some(item => item.id === id)) return;
      if (event.NotificationGuid) state.inboxUnreadCount += 1;
      state.notifications.push({
        id,
        persistent: !!event.NotificationGuid,
        avatar: { name: event.FromUserName || 'Jurat System', size: 'xl' },
        children: event.Message || event.Title || 'Share request updated',
        plainText: true,
        time: event.TimestampUtc || moment().utc().format(),
        className: 'rounded-0 border-x-0 border-300 border-bottom-0',
        unread: true,
        to
      });
    },
    addNotificationItem: (state, action) => {
      state.notifications = _.concat([], state.notifications, {
        ...action.payload.item
      });
    },

    markNotificationRead: (state, action) => {
      let updatedNotification = [];
      _.map(state.notifications, n => {
        if (n.id === action.payload || action.payload === null) {
          if (action.payload !== null && n.persistent && n.unread)
            state.inboxUnreadCount = Math.max(0, state.inboxUnreadCount - 1);
          n.unread = false;
        }
        updatedNotification.push(n);
      });
      state.notifications = updatedNotification;
      if (action.payload === null) state.inboxUnreadCount = 0;
    },

    clearNotification: (state, action) => {
      state.notifications = [];
      state.inboxUnreadCount = 0;
      state.inboxOwnerGuid = null;
      state.inboxError = null;
    }
  }
});

let { addNotificationItem, markNotificationRead, clearNotification } =
  notificationSlice.actions;

let actions = {
  actionAddNotification: messageObject => {
    return (dispatch, getState) => {
      return Promise.all([
        dispatch(
          addNotificationItem({
            item: {
              id: idGenerator.getNotificationItemId(),
              avatar: {
                name: messageObject.name || 'Jurat System',
                size: 'xl'
              },
              children: capitalize(messageObject.message.toLowerCase()),
              time: moment().utc().format(),
              emoji: '💬',
              className: 'rounded-0 border-x-0 border-300 border-bottom-0',
              unread: true,
              to: messageObject.to || '#!'
            }
          })
        )
      ]);
    };
  },

  actionMarkNotificationRead: id => {
    return (dispatch, getState) => {
      return Promise.all([dispatch(markNotificationRead(id))]);
    };
  },

  actionClearNotification: () => {
    return (dispatch, getState) => {
      return Promise.all([dispatch(clearNotification())]);
    };
  }
};

export const {
  actionAddNotification,
  actionMarkNotificationRead,
  actionClearNotification
} = actions;

export default notificationSlice.reducer;
